/**
 * 图表相关工具函数
 */
import {mockQuerySchemaData} from '../mock/schemaData'
import {updatePanelWidget} from '../utils/utils'
/**
 * 根据维度字段聚合数据
 * @param {Array} data - 原始数据数组
 * @param {String} dimensionField - 维度字段名
 * @param {String} measureField - 度量字段名
 * @param {String} aggregatorType - 聚合类型：sum, avg, max, min, count
 * @returns {Array} 聚合后的数据数组
 */
export function aggregateDataByDimension(data, dimensionField, measureField, aggregatorType = 'sum') {
  if (!data || !Array.isArray(data) || !dimensionField || !measureField) {
    return data || []
  }
  
  const aggregatedMap = new Map()
  
  data.forEach(item => {
    const dimensionValue = item[dimensionField]
    const measureValue = parseFloat(item[measureField]) || 0
    
    if (aggregatedMap.has(dimensionValue)) {
      const existingItem = aggregatedMap.get(dimensionValue)
      
      switch (aggregatorType) {
        case 'sum':
          existingItem[measureField] += measureValue
          break
        case 'avg':
          existingItem[measureField] = (existingItem[measureField] + measureValue) / 2
          break
        case 'max':
          existingItem[measureField] = Math.max(existingItem[measureField], measureValue)
          break
        case 'min':
          existingItem[measureField] = Math.min(existingItem[measureField], measureValue)
          break
        case 'count':
          existingItem[measureField] += 1
          break
        default:
          existingItem[measureField] += measureValue
      }
      
      // 保留其他字段的最新值
      Object.keys(item).forEach(key => {
        if (key !== dimensionField && key !== measureField) {
          existingItem[key] = item[key]
        }
      })
    } else {
      const newItem = { ...item }
      newItem[measureField] = measureValue
      aggregatedMap.set(dimensionValue, newItem)
    }
  })
  
  return Array.from(aggregatedMap.values())
}

export function elResizeObverse(el, cb) {
  let observer = null
  let willDoFlag = false
  let canRefresh = false
  let tempFn = () => {
    // 如果前置任务都完成了
    if (!willDoFlag) {
      willDoFlag = true
      // 既然前置任务已经没有了，那么就可以更新了？
      // 不是的，可能非常短的时间里，后续有改变
      // 因此延迟一点点来看看后续有没有改变
      // 如果改变了，就再延迟看看
      let interval = window.setInterval(function () {
        // 判断当前是否可以立刻更新
        if (!canRefresh) {
          window.clearInterval(interval)
          willDoFlag = false
          cb()
        }
        canRefresh = false
      }, 100)
    } else {
      canRefresh = true
    }
  }
  try {
    observer = new ResizeObserver(tempFn)
    observer.observe(el)
  } catch (e) {
    // 如果浏览器不支持此接口
    if (_support_) {
      console.error('浏览器不支持ResizeObserver')
      // 不支持的话，提示一次就可以了
      _support_ = false
    }
    // 使用resize进行退化支持
    tempFn()
    window.addEventListener('resize', tempFn, false)
  }
  return function () {
    if (observer) {
      // 解除对画布大小改变的监听
      observer.disconnect()
    }
  }
}


export function getParamsRowsAndColumns(fields) {
  const fieldsClone = JSON.parse(JSON.stringify(fields))
  const dataTransfer = (list) => {
    list = Array.isArray(list) ? list : list?.chooseFields ?? []
    return list.map((v) => {
      return {
        columnCode: v.unitCode,
        aggregatorType: v.aggregatorType,
      }
    })
  }
  console.log('fieldsClonefieldsClonefieldsClone:',fieldsClone)
  const rows = fieldsClone.filter((v) => v.queryType === 'rows')
  const columnCodes = fieldsClone
    .filter((v) => ['values', 'columns'].includes(v.queryType))
    .reduce((t, c) => {
      t.chooseFields = t.chooseFields.concat(c.chooseFields)
      return t.chooseFields
    })
  return {
    rowsCodes: dataTransfer(rows[0]?.['chooseFields']),
    columnCodes: dataTransfer(columnCodes),
  }
}


/**
 * 格式化图表数据
 * @param {Array} data - 原始数据
 * @param {Object} config - 配置对象
 * @returns {Array} 格式化后的数据
 */
export function formatChartData(data, config) {
  if (!data || !Array.isArray(data)) {
    return []
  }
  
  const { dimensionField, measureField, aggregatorType = 'sum' } = config
  
  if (dimensionField && measureField) {
    return aggregateDataByDimension(data, dimensionField, measureField, aggregatorType)
  }
  
  return data
}

/**
 * 生成图表颜色
 * @param {String} baseColor - 基础颜色
 * @param {Number} opacity - 透明度 (0-1)
 * @returns {String} 颜色字符串
 */
export function generateChartColor(baseColor, opacity = 1) {
  if (!baseColor) return baseColor
  
  if (baseColor.startsWith('#')) {
    const r = parseInt(baseColor.slice(1, 3), 16)
    const g = parseInt(baseColor.slice(3, 5), 16)
    const b = parseInt(baseColor.slice(5, 7), 16)
    return `rgba(${r}, ${g}, ${b}, ${opacity})`
  }
  
  return baseColor
}

/**
 * 计算图表尺寸
 * @param {Object} container - 容器元素
 * @param {Object} options - 选项
 * @returns {Object} 尺寸对象
 */
export function calculateChartSize(container, options = {}) {
  const { padding = 20, minWidth = 200, minHeight = 150 } = options
  
  if (!container) {
    return { width: minWidth, height: minHeight }
  }
  
  const rect = container.getBoundingClientRect()
  const width = Math.max(rect.width - padding * 2, minWidth)
  const height = Math.max(rect.height - padding * 2, minHeight)
  
  return { width, height }
}


export async function updateChartDataHelper(selectItem, vm, custom_updateData) {
  const { dataSetId } = selectItem;
  const { rowsCodes, columnCodes } = getParamsRowsAndColumns(selectItem.fields);
  try {
    const params = {
      faceTableCode: dataSetId,
      rowsCodes,
      columnCodes,
    };
    let { data: response } = vm.custom_updateData
      ? await custom_updateData(selectItem)
      : await mockQuerySchemaData(params);
    // 更新 selectItem
    vm.$set(selectItem, "describe", response.describe);
    vm.$set(selectItem, "describeShow", false);
    // selectItem.data = null
    vm.$emit("updateDashboard", selectItem);
    vm.$nextTick(() => {
      custom_updateData
        ? (selectItem.data.data = response)
        : (selectItem.data = response);
      updatePanelWidget(selectItem, true);
      vm.$emit("updateDashboard", selectItem);
    });
  } catch (e) {
    console.log(e);
    vm.$message.error("更新失败");
  }
}